import { render, staticRenderFns } from "./SubscriptionPlanRedesign.vue?vue&type=template&id=4dcf781a&scoped=true&"
import script from "./SubscriptionPlanRedesign.vue?vue&type=script&lang=ts&"
export * from "./SubscriptionPlanRedesign.vue?vue&type=script&lang=ts&"
import style0 from "./SubscriptionPlanRedesign.vue?vue&type=style&index=0&id=4dcf781a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dcf781a",
  null
  
)

export default component.exports